import { Button, Flex, Tag, Text } from '@grammarly/design-system'
import classes from './AdvancedSuggestionsContent.module.scss'

const DEFAULT_ADVANCED_SUGGESTIONS_CTA_COPY = 'Pro suggestions found'

export interface AdvancedSuggestionsContentProps {
  readonly suggestionCount: number
  readonly secondaryCtaCopy?: string
  readonly onSecondaryCtaClick?: () => void
}

export const AdvancedSuggestionsContent = (props: AdvancedSuggestionsContentProps) => {
  const { suggestionCount, secondaryCtaCopy, onSecondaryCtaClick } = props

  const label = suggestionCount > 99 ? '99+' : `${suggestionCount}+`

  return (
    <Flex
      className={classes.advancedSuggestionsContent}
      gap={1}
      align="center"
      justify="space-between"
    >
      <Tag
        className={classes.counter}
        variant="premium"
        showIcon={false}
        label={label}
        accessibilityLabel={`${suggestionCount} suggestions`}
      />
      {onSecondaryCtaClick ? (
        <AdvancedSuggestionsSecondaryCta text={secondaryCtaCopy} onClick={onSecondaryCtaClick} />
      ) : (
        <AdvancedSuggestionsSecondaryTitle>{secondaryCtaCopy}</AdvancedSuggestionsSecondaryTitle>
      )}
    </Flex>
  )
}

const AdvancedSuggestionsSecondaryCta = ({
  text,
  onClick,
}: {
  readonly text?: string
  readonly onClick?: () => void
}) => {
  return (
    <Button className={classes.secondaryCtaButton} onClick={onClick} variant="ghost" size="small">
      <AdvancedSuggestionsSecondaryTitle>{text}</AdvancedSuggestionsSecondaryTitle>
    </Button>
  )
}

const AdvancedSuggestionsSecondaryTitle = ({ children }: React.PropsWithChildren) => {
  return (
    <Text
      as="span"
      weight="medium"
      variant="text-xsmall"
      className={classes.secondaryCtaButtonText}
    >
      {children ?? DEFAULT_ADVANCED_SUGGESTIONS_CTA_COPY}
    </Text>
  )
}
